import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import {withRouter, Link, Redirect} from 'react-router-dom'
import { Input, Button, message, Modal } from 'antd'
import Cookies from 'js-cookie'
import { userLogin } from 'request/user'
import { getByDomain } from 'request/personalize'
import { actionCreators } from '@/store'
import { TOKEN_KEY } from '../../constants'
import LoginCommonFrame from '@/components/container/login-common-frame'
import './style.scss'
const { confirm } = Modal

function Login(props) {
  const { setLoginStatus, isLogin } = props
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [personalize, setPersonalize] = useState({})

  useEffect(() => {
    getPersonalize().catch(e => console.log(e.message))
  }, [])

  useEffect(() => {
    if (!personalize || !Object.keys(personalize).length) {
      return
    }
    document.title = personalize.domain ? '设备管理平台' : '芯博士网络设备管理平台'
  }, [personalize])

  const getPersonalize = async() => {
    const { success, data } = await getByDomain({ domain: document.domain })
    if (success) {
      data.logo = data.logo || '//www.simboss.com/images/logo.png'
      setPersonalize(data)
    }
  }

  const onAccountChange = e => {
    setAccount(e.target.value)
  }

  const onPasswordChange = e => {
    setPassword(e.target.value)
  }

  const changeWeakPwd = () => {
    confirm({
      width: 500,
      title: '密码等级过低提示',
      icon: <ExclamationCircleOutlined />,
      okText: '修改密码',
      cancelText: '取消',
      content: (
        <>
          <p>当前系统检测到您的账号密码等级过低，不符合网络安全要求，需要您修改密码后再登录系统！</p>
          <p>密码组成建议：8-20位，并且包含大写字母、小写宇母、数字和特殊字符中三种及以上组合；</p>
          <p>如无法修改，请联系人工客服;</p>
        </>
      ),
      onOk() {
        props.history.push('/forgetPassword')
      },
      onCancel() {}
    })
  }
  const loginBtnClick = async() => {
    if (!account.trim()) {
      message.warn('账户不能为空')
      return false
    }
    if (!password.trim()) {
      message.warn('密码不能为空')
      return false
    }
    const res = await userLogin({ account: account.trim(), pwd: password.trim() })
    if (res.message.indexOf('弱密码') !== -1) {
      changeWeakPwd()
      return
    }
    if (!res.success) {
      message.error(res.message)
      return false
    }
    Cookies.set(TOKEN_KEY, res.data.token, { expires: 1 }) // 设置token有效期1天
    setLoginStatus(true)
  }
  return (
    isLogin ? <Redirect to="/"/> : (
      <LoginCommonFrame title="欢迎登陆">
        <p>
          <Input size="large" value={account} onChange={onAccountChange} placeholder="请输入手机号/账户名"/>
        </p>
        <p>
          <Input
            size="large"
            value={password}
            type="password"
            onChange={onPasswordChange}
            placeholder="请输入密码"
          />
        </p>
        <p>
          <Button size="large" className="login-btn" onClick={loginBtnClick} type="primary">立即登录</Button>
        </p>
        <div>
          没有账号，<Link to="/register">立即注册</Link>
          <span className="login-forget-password">
            <Link to="/forgetPassword">忘记密码？</Link>
          </span>
        </div>
      </LoginCommonFrame>
    )
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin'])
}), dispatch => ({
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(withRouter(Login))
